type ApiData = {
    api?: string;
}

const PrefixBeta: ApiData = {
    api: 'api/beta1',
};

export default PrefixBeta;